<template>
  <div :class="$style.changePwd">
    <header>
      <i class="iconfont yw-xiangzuo" @click="$emit('close')" />
      <span>修改密码</span>
      <img :src="`${this.$cdnLink}/suspend/tongyong/guanbi.png`" alt @click="$emit('closePage')" :class="$style.closePage" />
    </header>
    <div v-if="!useTelCode">
      <div :class="$style.inputWrap">
        <img :src="`${this.$cdnLink}/suspend/mine/lock.png`" alt />
        <input type="text" v-model.trim="form.oldPwd" placeholder="请输入旧密码" />
      </div>
      <div :class="$style.inputWrap">
        <img :src="`${this.$cdnLink}/suspend/mine/lock.png`" />
        <input type="text" v-model.trim="form.newPwd" placeholder="请输入新密码" />
      </div>
      <div :class="$style.inputWrap">
        <img :src="`${this.$cdnLink}/suspend/mine/lock.png`" />
        <input type="text" v-model.trim="form.confirmPwd" placeholder="请再次输入新密码" />
      </div>
    </div>
    <div v-else>
      <div :class="$style.inputWrap">
        <img :src="`${this.$cdnLink}/suspend/mine/phone.png`" />
        <span>{{ geTel(userState.tel_num) }}</span>
      </div>
      <div :class="$style.inputWrap">
        <img :src="`${this.$cdnLink}/suspend/mine/lock.png`" />
        <input type="text" v-model.trim="form.newPwd" placeholder="请输入新密码" />
      </div>
      <div :class="[$style.inputWrap, $style.code]">
        <img :src="`${this.$cdnLink}/suspend/mine/verify.png?v=1`"/>
        <input type="number" v-model.trim="code" placeholder="请输入验证码" />
        <span v-if="timer">{{ count }}S</span>
        <span v-else :class="$style.retry" @click="getCode">发送验证</span>
      </div>
    </div>
    <button :class="$style.submit" @click="submit">确定</button>
  </div>
</template>

<script>
import { saveAccount, getAccount, setStorage } from '@/libs/utils';
import { mapActions, mapMutations, mapState } from 'vuex';
import { regexpVerify } from '@/libs/business/account';
import { userChangePwd, getSmsCodeV2, cellResetPwd } from '@/api/user';
import CryptoJS from 'crypto-js';
import { geTel } from '@/libs/utils';

export default {
  name: '',
  data() {
    return {
      form: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: '',
      },
      useTelCode: false,
      code: '',
      count: '',
      timer: null,
      geTel,
    };
  },
  mounted() {
    this.getCutPswd();
    if (this.userState.tel_status == 1 && this.userState.tel_num) {
      this.useTelCode = true;
    }
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
  },
  methods: {
    ...mapActions({
      modifyPwd: 'user/modifyPwd',
    }),
    ...mapMutations({
      changeUserState: 'user/CHANGE_STATE',
      showLoading: 'global/showLoading',
    }),
    getCutPswd() {
      this.list = getAccount() || [];
      this.form.oldPwd = this.list.length ? this.list[0].password : '';
    },
    async submit() {
      if (!this.useTelCode) {
        await regexpVerify(this.form, [
          { key: 'oldPwd', hint: '请输入旧密码' },
          { key: 'newPwd', hint: '密码由6-18位数字或字母组成', type: 'password' },
          { key: 'confirmPwd', hint: '密码由6-18位数字或字母组成', type: 'password' },
        ]);
        if (this.form.newPwd !== this.form.confirmPwd) {
          this.$toast('新密码与旧密码输入不一致');
          return;
        }
        const { username, password, user_id, appkey, access_token } = this.userState;
        const { newPwd, oldPwd } = this.form;
        this.showLoading();
        const r = await userChangePwd({
          user_name: username,
          cur_password: CryptoJS.MD5(oldPwd + CryptoJS.MD5(oldPwd)).toString(),
          new_password: CryptoJS.MD5(newPwd + CryptoJS.MD5(newPwd)).toString(),
          user_id: user_id,
          appkey: appkey,
          access_token: access_token,
        });
        this.$toast('修改成功');
        this.changeUserState({ password: newPwd });
        saveAccount(username, newPwd);
        this.$emit('close');
      } else {
        await regexpVerify({
          newPwd: this.form.newPwd,
          code: this.code
        }, [
          { key: 'code', hint: '请输入验证码' },
          { key: 'newPwd', hint: '密码由6-18位数字或字母组成', type: 'password' },
        ]);

        const { user_id, appkey } = this.userState
        this.showLoading();
        await cellResetPwd({
          password: CryptoJS.MD5(this.form.newPwd + CryptoJS.MD5(this.form.newPwd)).toString(),
          user_id: user_id,
          appkey: appkey,
          code: this.code,
        });
        this.$toast('修改成功');
        this.changeUserState({ password: this.form.newPwd });
        saveAccount(this.userState.tel_num, this.form.newPwd );
        this.$emit('close');
      }
    },
    async getCode() {
      const { appkey, user_id } = this.userState;
      this.setTimer();
      try {
        await getSmsCodeV2({
          user_id: user_id,
          appkey: appkey,
          type: 'reset'
        });
        this.$toast('发送成功');
      } catch (error) {
        this.clearTimer();
      }
    },
    setTimer() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    clearTimer() {
      this.count = '';
      clearInterval(this.timer);
      this.timer = null;
    },
  },
};
</script>

<style lang="scss" module>
.changePwd {
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  > header {
    position: relative;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    height: 40px;
    padding: 0 15px;
    color: #7a7979;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 40px;
    :global {
      .yw-xiangzuo {
        width: 15px;
        height: 15px;
        color: #7a7979;
      }
    }
    .closePage {
      height: 13px;
    }
  }
  .inputWrap {
    display: flex;
    border-bottom: 1px solid #ebebeb;
    margin: 0 22px 12px;
    padding: 6px 9px;
    position: relative;
    > span {
      font-size: 15px;
    }
    > img {
      width: 13px;
      height: 15px;
      margin-right: 14px;
    }
    > input {
      border: none;
      font-size: 15px;
    }
    &.code {
      > img {
        height: 16px;
      }
    }
    .retry {
      position: absolute;
      right: 8px;
      color: #ff5b58;
    }
  }
  .submit {
    margin: 54px auto 0;
    width: 293px;
    height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 15px;
    border: none;
    outline: none;
    background: #ff5b58;
    border-radius: 20px;
  }
}
</style>
